module.exports = __webpack_public_path__ + "media/images/cplook/favicon-cb21edcbcc5608698eca8895f3171fec.ico";